import { motion } from "framer-motion";
import { JOIN } from "@/constants/testIds";
import { scrollToId } from "./joinData";

export default function JoinHero() {
  return (
    <section
      data-testid={JOIN.hero}
      style={{
        position: "relative",
        minHeight: "88vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        color: "#ffffff",
        marginTop: -70,
        paddingTop: 100,
        paddingBottom: 80,
        background: "var(--color-brand-dark)",
        isolation: "isolate",
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          zIndex: -2,
          backgroundImage: "url('/images/join-hero.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.4,
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          zIndex: -1,
          background:
            "linear-gradient(120deg, rgba(30,37,84,0.92) 0%, rgba(28,30,84,0.78) 55%, rgba(30,37,84,0.55) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          top: "-20%",
          right: "-10%",
          width: 640,
          height: 640,
          borderRadius: 999,
          background:
            "radial-gradient(circle, rgba(108,92,231,0.28) 0%, rgba(108,92,231,0) 60%)",
          zIndex: -1,
          filter: "blur(20px)",
        }}
      />

      <motion.div
        className="container-wide"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.85, ease: [0.4, 0, 0.2, 1] }}
        style={{ position: "relative", zIndex: 1, maxWidth: 900 }}
      >
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="inline-flex items-center gap-2 mb-6"
          style={{
            padding: "6px 14px",
            borderRadius: 999,
            background: "rgba(255,255,255,0.08)",
            backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.18)",
            fontSize: 12,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.9)",
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: 999,
              background: "var(--color-success)",
              boxShadow: "0 0 8px var(--color-success)",
            }}
          />
          Agent program · Now accepting applications
        </motion.div>

        <h1
          className="type-display-hero"
          style={{
            color: "#ffffff",
            maxWidth: 780,
            marginBottom: 20,
            textShadow: "0 2px 12px rgba(0,0,0,0.35)",
          }}
        >
          Build Your Legacy.
          <br />
          <span style={{ color: "#b9b9f9" }}>Earn Unlimited Residual Income.</span>
        </h1>
        <p
          className="type-body-large"
          style={{ color: "rgba(255,255,255,0.9)", maxWidth: 640, marginBottom: 40 }}
        >
          Join SmartEdge as an agent to offer exclusive tax-saving and wellness programs
          to businesses. Earn monthly residual income on every client you secure —
          with unlimited earning potential.
        </p>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="#apply"
            data-testid={JOIN.heroCtaApply}
            className="btn-primary btn-primary--lg"
            onClick={scrollToId("#apply")}
          >
            Apply to Join Our Team
          </a>
          <a
            href="#opportunity"
            data-testid={JOIN.heroCtaLearn}
            className="btn-ghost btn-ghost--invert"
            onClick={scrollToId("#opportunity")}
          >
            Learn About the Program
          </a>
        </div>

        <div
          className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3"
          style={{ color: "rgba(255,255,255,0.75)" }}
        >
          {[
            "200+ partner referrals",
            "$18M+ client savings generated",
            "Monthly residual payments",
          ].map((t, i) => (
            <motion.span
              key={t}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35 + i * 0.12, duration: 0.5 }}
              style={{ fontSize: 13, letterSpacing: "0.02em" }}
            >
              {i > 0 && (
                <span aria-hidden="true" style={{ marginRight: 24, opacity: 0.4 }}>|</span>
              )}
              {t}
            </motion.span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
